import { useFormContext } from 'react-hook-form'

import { Database } from '@fortem-monorepo/constants'
import { FormError, FormLabel, RadioLarge } from '@fortem-monorepo/react-ui'
import { FormField, FormItem } from '@fortem-monorepo/react-ui'

export interface DatabaseFormFieldProps {
  showLabel?: boolean
}

export const DatabaseFormField: React.FC<DatabaseFormFieldProps> = ({ showLabel = false }) => {
  const { control } = useFormContext<{ database: Database }>()

  return (
    <FormField
      name="database"
      control={control}
      render={({ field }) => {
        return (
          <FormItem>
            {showLabel && (
              <div className="flex items-center gap-2">
                <FormLabel>Database</FormLabel>
                <FormError />
              </div>
            )}
            <div className={'@container flex flex-col gap-2'}>
              <div className={'w-full flex flex-col @sm:flex-row flex-1 gap-2'}>
                <RadioLarge {...field} value="old" checked={field.value === 'old'}>
                  Old DB
                </RadioLarge>
                <RadioLarge {...field} value="new" checked={field.value === 'new'}>
                  New DB
                </RadioLarge>
              </div>
              <RadioLarge {...field} value="both" checked={field.value === 'both'}>
                Both
              </RadioLarge>
            </div>
          </FormItem>
        )
      }}
    />
  )
}
